import {
  type ActionReducerMapBuilder,
  createAction,
  createSlice,
  type PayloadAction,
} from '@reduxjs/toolkit';
import { type CaseReportsState } from '../../types/store/states/CaseReportState';

const initialState: CaseReportsState = {
  openDialog: false,
  openRemovalDialog: false,
  cdrId: null,
  textMessageId: null,
} as CaseReportsState;

type dialogOpen = {
  cdrId: number;
  textMessageId: number;
};
const dialogOpenAction = createAction<dialogOpen>('caseReport/dialogOpen');
const removalDialogOpenAction = createAction<dialogOpen>(
  'caseReport/removalDialogOpen',
);

const caseReports = createSlice({
  reducerPath: undefined,
  selectors: undefined,
  reducers: {},
  name: 'caseReport',
  initialState,
  extraReducers: (builder: ActionReducerMapBuilder<CaseReportsState>) => {
    builder
      .addCase(dialogOpenAction, (state, action: PayloadAction<dialogOpen>) => {
        state.openDialog = true;
        state.cdrId = action.payload.cdrId;
        state.textMessageId = action.payload.textMessageId;
      })
      .addCase('caseReport/dialogClose', (state) => {
        state.openDialog = false;
        state.openRemovalDialog = false;
        state.cdrId = null;
        state.textMessageId = null;
      })
      .addCase(
        removalDialogOpenAction,
        (state, action: PayloadAction<dialogOpen>) => {
          state.openRemovalDialog = true;
          state.cdrId = action.payload.cdrId;
          state.textMessageId = action.payload.textMessageId;
        },
      );
  },
});

export default caseReports.reducer;
